import React, {FC} from "react"
import {BenefitCardInfo} from "@irati-web/benefits/components/benefitCardInfo"
import {BenefitSteps} from "@irati-web/benefits/components/benefitSteps"
import {BenefitFAQ} from "@irati-web/benefits/components/benefitFAQ"
import theme from "@irati/ui/src/global/theme"
import {IconTypes} from "@irati/ui/src/Icon"
import {BenefitHeader} from "@irati-web/benefits/components/benefitHeader"
import Alert, {AlertTypes} from "@irati/ui/src/Alert"
import {Grid} from "react-bootstrap"

const AnnualLeavePurchaseLandingScreen: FC = () => {
  return (
    <>
      <Grid>
        <BenefitHeader
          secondCtaUrl="/annual_leave_purchase/landing"
          secondCtaTitle="annualLeavePurchase.landing.sectionOne.cta.text"
          title="annualLeavePurchase.landing.title"
        />
        <Alert padding={1} nonDismissable type={AlertTypes.warning} title="annualLeavePurchase.landing.section.general.alert.text" />
        <BenefitCardInfo
          title="annualLeavePurchase.landing.sectionOne.subtitle"
          imagePosition="right"
          imageSrc="annualLeavePurchase.landing.section.general.new.imageRight.src"
          tilesData={tilesData}
        />
      </Grid>

      <BenefitSteps
        title="annualLeavePurchase.landing.steps.start.title"
        firstStepCtaTitle="annualLeavePurchase.landing.steps.ctaOne.title"
        secondStepCtaTitle="annualLeavePurchase.landing.steps.ctaTwo.title"
        firstStepCtaUrl="/annual_leave_purchase/landing"
        secondStepCtaUrl="/annual_leave_purchase/landing"
        items={steps}
        itemsPerRow={3}
      />

      <Grid>
        <BenefitCardInfo
          title="annualLeavePurchase.landing.sectionTwo.subTitle"
          imagePosition="left"
          imageSrc="annualLeavePurchase.landing.section.general.new.imageLeft.src"
          ctaText="annualLeavePurchase.landing.sectionOne.cta.text"
          ctaUrl="/annual_leave_purchase/landing"
          body="annualLeavePurchase.landing.sectionTwo.body"
        />
        <BenefitFAQ
          title="annualLeavePurchase.landing.faq.title"
          faqCtaText="annualLeavePurchase.landing.faq.accessCTA"
          subtitle="annualLeavePurchase.landing.faq.subtitle"
          faqCtaUrl="/annual_leave_purchase/landing"
        />
      </Grid>
    </>
  )
}

export default AnnualLeavePurchaseLandingScreen

const steps = [
  {
    title: "annualLeavePurchase.landing.steps.stepOne.title",
    subTitle: "annualLeavePurchase.landing.steps.stepOne.subTitle",
    image: "https://res.cloudinary.com/perkbox/image/upload/v1742926537/0ff02d1a-a809-4510-9bae-e281e2b08509.png"
  },
  {
    title: "annualLeavePurchase.landing.steps.stepTwo.title",
    subTitle: "annualLeavePurchase.landing.steps.stepTwo.subTitle",
    image: "https://res.cloudinary.com/perkbox/image/upload/v1742926613/37896af2-9483-47c9-9cdb-9edaf2ee476a.png"
  },
  {
    title: "annualLeavePurchase.landing.steps.stepThree.new.title",
    subTitle: "annualLeavePurchase.landing.steps.stepThree.new.subTitle",
    image: "https://res.cloudinary.com/perkbox/image/upload/v1742926648/9c5c73c8-3f04-4a77-9d3b-377bdb02a898.png"
  }
]

const tilesData = [
  {
    description: "annualLeavePurchase.landing.sectionOne.tile.titleOne",
    iconBgColor: theme.colors.success,
    iconColor: theme.colors.greys.white,
    iconName: IconTypes.psychiatry
  },
  {
    description: "annualLeavePurchase.landing.sectionOne.tile.titleTwo",
    iconColor: theme.colors.greys.white,
    iconBgColor: theme.colors.tertiary.s2_400,
    iconName: IconTypes.thumbUp
  },
  {
    description: "annualLeavePurchase.landing.sectionOne.tile.titleThree",
    iconColor: theme.colors.greys.white,
    iconBgColor: theme.colors.tertiary.g_600,
    iconName: IconTypes.savings
  }
]
